// Componente actualizado con MUI v5 y DataGrid en lugar de MaterialTable
import React, { Component } from 'react';
import './PerfilMobiliarioCalProg.css';
import { getprogcalsactivo, clearErrors, deleteProgCalActivo, postCalibracionActivo } from '../../../redux/actions/mobiliarioactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaCheck, FaCheckCircle, FaPlus, FaTrash } from 'react-icons/fa';
import { DataGrid } from '@mui/x-data-grid';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, CircularProgress, IconButton, Tooltip, Stack,
  Grid
} from '@mui/material';
import MyButton from '../../../utils/MyButton';
import { esES } from '@mui/x-data-grid';

class PerfilMobiliarioCalProg extends Component {
  state = {
    horainicio: '',
    horafinal: '',
    fecha: '',
    numcertificado: '',
    errors: {},
    open: false,
    opendelete: false,
    progid: '',
    aprobado: {}
  };

  componentDidMount() {
    this.props.getprogcalsactivo(this.props.mobiliarioId);
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpen = (progid, fecha, hora) => {
    this.setState({ open: true, progid, fecha, horainicio: hora, aprobado: {} });
  };

  handleClose = () => {
    const resetState = { open: false, errors: {}, aprobado: {} };
    if (this.state.aprobado.mensaje) this.props.getprogcalsactivo(this.props.mobiliarioId);
    this.setState(resetState);
  };

  handleOpenDelete = (progid) => {
    this.setState({ opendelete: true, progid, aprobado: {}, errors: {} });
  };

  handleCloseDelete = () => {
    this.setState({ opendelete: false, aprobado: {}, errors: {} });
  };

  handleDelete = () => {
    const { credentials } = this.props.user;
    const handleUser = credentials.tipouser === 'Tecnico' ? credentials.handleuser : credentials.handle;
    this.props.deleteProgCalActivo(this.state.progid, this.props.mobiliarioId, this.props.clienteId, handleUser);
  };

  handlePostCal = () => {
    const { credentials } = this.props.user;
    const handleUser = credentials.tipouser === 'Tecnico' ? credentials.handleuser : credentials.handle;
    const newCalibracion = {
      fecha: this.state.fecha,
      horainicio: this.state.horainicio,
      horafinal: this.state.horafinal,
      numcertificado: this.state.numcertificado,
      progid: this.state.progid
    };
    this.props.postCalibracionActivo(newCalibracion, this.props.clienteId, this.props.mobiliarioId, handleUser);
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { progcalsmobiliario, loadingcal } = this.props.dataMob;
    const { errors, aprobado, open, opendelete } = this.state;
    const { UI: { loading } } = this.props;

    const columns = [
        {
            field: 'acciones',
            headerName: 'Acciones',
            width: 120,
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
            renderCell: (params) => (
              <Stack direction="row" spacing={1}>
                <Tooltip title="Realizar Calibración">
                  <span>
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => this.handleOpen(params.row.progid, params.row.fecha, params.row.hora)}
                      disabled={params.row.estado === 'Realizado'}
                    >
                      <FaPlus size={16} />
                    </IconButton>
                  </span>
                </Tooltip>
                <Tooltip title="Borrar Programación">
                  <IconButton
                    size="small"
                    color="#d7d7d7"
                    onClick={() => this.handleOpenDelete(params.row.progid)}
                  >
                    <FaTrash size={16} />
                  </IconButton>
                </Tooltip>
              </Stack>
            )
          },
      { field: 'fecha', headerName: 'Fecha', flex:1, minwidth:120},
      { field: 'mesnombre', headerName: 'Mes', flex:1, minwidth:120 },
      { field: 'hora', headerName: 'Hora', flex:1, minwidth:120},
      { field: 'duracion', headerName: 'Duración', flex:1, minwidth:120},
      { field: 'estado', headerName: 'Estado', flex:1, minwidth:120 },
      { field: 'lugar', headerName: 'Lugar', flex:1, minwidth:120},
      
    ];

    return (
      <div className="listamtoprog-container">
        <div className="listamtoprog-table">
          {loadingcal ? (
            <div className="div_cargando">
              <CircularProgress size={50} color="primary" className="login-progress" />
            </div>
          ) : (
            <DataGrid
              rows={progcalsmobiliario}
              columns={columns}
              autoHeight
              pageSize={5}
              getRowId={(row) => row.progid}              
              rowsPerPageOptions={[5, 10, 20]}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText} // 👈 Esto cambia TODO a Español
             
              sx={{
                borderRadius: 2,
                backgroundColor: '#fff',
                boxShadow: 3,
                '& .MuiDataGrid-cell': {
                  fontSize: 14,
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#0588FB',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: 15,
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
               disableSelectionOnClick
            />
          )}
        </div>

        <Dialog open={open} onClose={this.handleClose} fullWidth maxWidth="sm">
          {aprobado.mensaje ? (
            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
            </div>
          ) : (
            <>
              <DialogTitle>Realizar Calibración</DialogTitle>
              <DialogContent>
                <form>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={12}>
                      <TextField fullWidth required type="date" name="fecha" label="Fecha de Realización"
                        value={this.state.fecha} onChange={this.handleChange} helperText={errors.fecha}
                        error={Boolean(errors.fecha)} InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField fullWidth required type="time" name="horainicio" label="Hora de Inicio"
                        value={this.state.horainicio} onChange={this.handleChange} helperText={errors.horainicio}
                        error={Boolean(errors.horainicio)} InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField fullWidth required type="time" name="horafinal" label="Hora Final"
                        value={this.state.horafinal} onChange={this.handleChange} helperText={errors.horafinal}
                        error={Boolean(errors.horafinal)} InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField fullWidth required name="numcertificado" label="Numero del Certificado"
                        value={this.state.numcertificado} onChange={this.handleChange} helperText={errors.numcertificado}
                        error={Boolean(errors.numcertificado)} InputLabelProps={{ shrink: true }} />
                    </Grid>
                  </Grid>
                </form>
              </DialogContent>
            </>
          )}
          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}><FaArrowLeft color="#D3D7DC" className="icon-formulario" /></MyButton>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : aprobado.mensaje ? (
              <MyButton tip="Continuar" onClick={this.handleClose}><FaCheckCircle color="#20B90C" className="icon-formulario" /></MyButton>
            ) : (
              <MyButton tip="Realizar Calibración" onClick={this.handlePostCal}><FaPlus color="#03178C" className="icon-formulario" /></MyButton>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={opendelete} onClose={this.handleCloseDelete} fullWidth maxWidth="sm">
          {aprobado.mensaje ? (
            <div className='div-aprobado'>
              <div className='div-icono-delete'>
                <FaTrash color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>Programación Borrada Exitosamente</h2>
            </div>
          ) : (
            <DialogTitle>¿Estás seguro de borrar programación de Calibración?</DialogTitle>
          )}
          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseDelete}><FaArrowLeft color="#D3D7DC" className="icon-formulario" /></MyButton>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : aprobado.mensaje ? (
              <MyButton tip="Continuar" onClick={this.handleCloseDelete}><FaCheckCircle color="#f9044e" className="icon-formulario" /></MyButton>
            ) : (
              <MyButton tip="Borrar Programación" onClick={this.handleDelete}><FaTrash color="#03178C" className="icon-formulario" /></MyButton>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

PerfilMobiliarioCalProg.propTypes = {
  getprogcalsactivo: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  deleteProgCalActivo: PropTypes.func.isRequired,
  postCalibracionActivo: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  dataMob: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  clienteId: PropTypes.string,
  mobiliarioId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  data: state.data,
  dataMob: state.dataMob,
  user: state.user,
  UI: state.UI,
});

const mapActionsToProps = {
  getprogcalsactivo,
  clearErrors,
  deleteProgCalActivo,
  postCalibracionActivo
};

export default connect(mapStateToProps, mapActionsToProps)(PerfilMobiliarioCalProg);
